import React from "react";
import PropTypes from "prop-types";

import VisaLogo from "assets/images/payment/visa.png";
import MasterCardLogo from "assets/images/payment/mastercard.png";
import DiscoverLogo from "assets/images/payment/discover.png";
import AmexLogo from "assets/images/payment/amex.png";

import useStyles from "./useStyles";

const CARD_TYPES = {
  VISA: "Visa",
  MASTERCARD: "Mastercard",
  DISCOVER: "Discover",
  AMERICAN_EXPRESS: "American EXpress",
};

const CARD_LOGOS = {
  Visa: VisaLogo,
  Mastercard: MasterCardLogo,
  Discover: DiscoverLogo,
  "American EXpress": AmexLogo,
};

const PaymentMethods = ({ type }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {type ? (
        <div className={classes.logos}>
          <img src={CARD_LOGOS[type]} alt={type} className={classes.logo} />
        </div>
      ) : (
        <>
          <div className={classes.label}>
            <span className={classes.title}>Credit card</span>
            <span className={classes.subtitle}>Accepted payment methods</span>
          </div>
          <div className={classes.logos}>
            <img src={VisaLogo} alt={CARD_TYPES.VISA} className={classes.logo} />
            <img src={MasterCardLogo} alt={CARD_TYPES.MASTERCARD} className={classes.logo} />
            <img src={DiscoverLogo} alt={CARD_TYPES.DISCOVER} className={classes.logo} />
            <img src={AmexLogo} alt={CARD_TYPES.AMERICAN_EXPRESS} className={classes.logo} />
          </div>
        </>
      )}
    </div>
  );
};

PaymentMethods.propTypes = {
  type: PropTypes.string,
};

export default PaymentMethods;
